import React from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
} from '@ey-xd/motif-react';
import success from '@assets/icons/success.png';
import { useRecoilState, useRecoilValue } from 'recoil';
import { BUTTON_TITLE, SUBMITSUCCESSFUL } from '@constants/commonConstants';
import { BodyContent, HeaderWrapper, ParagraphStyle } from '@organisms/modals/styles/modalStyles';
import {
  Account_List,
  Current_User,
  Pl_Submit_Success_Modal_State,
  Recoil_Quarter_State,
  Refresh_Pl_Forecast_page,
  Refresh_Pills_Status_State,
} from '@recoil/recoil';
import { dateFormat, structureMonth } from '@util/commonUtil';
import { useNavigate } from 'react-router-dom';
import { ROLE_CONST } from '../../../constants/commonConstants';

const SuccessTransactionModal = () => {
  const [showSubmitSuccessModal, setShowSubmitSuccessModal] = useRecoilState(
    Pl_Submit_Success_Modal_State,
  );
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const userAccountList = useRecoilValue(Account_List);
  const [refreshPlForecastPage, setRefreshPlForecastPage] =
    useRecoilState(Refresh_Pl_Forecast_page);
  const [refreshPillStatus, setRefreshPillStatus] = useRecoilState(Refresh_Pills_Status_State);

  const currentMonthStartDate = quarterData ? dateFormat(quarterData.current_month_start_date) : '';
  const quarterStartDate = quarterData ? dateFormat(quarterData.quarter_start_date) : '';
  const startMonth = quarterStartDate.split(' ')[1];
  const currentMonth = currentMonthStartDate.split(' ')[1];
  const quarter = quarterData ? structureMonth(quarterData.quarter) : '';
  const quarterMonth = quarterData ? quarterData.month : '';

  const matchRole = userAccountList.find(item => item.role === currentUser.role);
  const selectedUser = JSON.parse(localStorage.getItem('selectedUser'));

  let AccountName = '';
  const navigate = useNavigate();
  if (matchRole) {
    const account_id_ = currentUser.account_id;
    const matchedAccount = matchRole.accountList.find(
      account => account.account_id === account_id_,
    );
    AccountName =
      selectedUser?.apiRole === ROLE_CONST.MSL_DELEGATE ? selectedUser?.name : matchedAccount?.name;
  } else {
    if (selectedUser?.apiRole === ROLE_CONST.MSL_DELEGATE) {
      AccountName = selectedUser?.name;
    }
  }

  const closeWarningModal = () => {
    setShowSubmitSuccessModal(false);
    sessionStorage.removeItem('rowData');
    setRefreshPlForecastPage(!refreshPlForecastPage);
    setRefreshPillStatus(!refreshPillStatus);
    navigate('/');
  };

  const closeWarningModalByCancel = () => {
    setShowSubmitSuccessModal(false);
    sessionStorage.removeItem('rowData');
    setRefreshPlForecastPage(!refreshPlForecastPage);
    setRefreshPillStatus(!refreshPillStatus);
    window.location.reload();
  };

  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;

  const bodyContent = () => {
    if (currentUser.role === 'PL') {
      if (currentMonth === startMonth) {
        return (
          <BodyContent>
            <p>
              {SUBMITSUCCESSFUL.DESCRIPTON1} {quarter} {SUBMITSUCCESSFUL.AND} {quarterMonth}{' '}
              {SUBMITSUCCESSFUL.DESCRIPTON2}{' '}
            </p>
          </BodyContent>
        );
      } else {
        return (
          <BodyContent>
            <p>
              {SUBMITSUCCESSFUL.DESCRIPTON1} {quarterMonth} {SUBMITSUCCESSFUL.DESCRIPTON2}{' '}
            </p>
          </BodyContent>
        );
      }
    } else if (currentUser.role === 'GCSP') {
      if (currentMonth === startMonth) {
        return (
          <BodyContent>
            <p>
              {SUBMITSUCCESSFUL.DESCRIPTON1} {quarter} {SUBMITSUCCESSFUL.AND} {quarterMonth}{' '}
              {SUBMITSUCCESSFUL.AND} {SUBMITSUCCESSFUL.PROJECTION}
              {SUBMITSUCCESSFUL.DESCRIPTON2} {`${SUBMITSUCCESSFUL.FOR} ${AccountName}`}.
            </p>
          </BodyContent>
        );
      } else {
        return (
          <BodyContent>
            <p>
              {SUBMITSUCCESSFUL.DESCRIPTON1} {quarterMonth} {SUBMITSUCCESSFUL.AND}{' '}
              {SUBMITSUCCESSFUL.PROJECTION} {SUBMITSUCCESSFUL.DESCRIPTON2}{' '}
              {`${SUBMITSUCCESSFUL.FOR} ${AccountName}`}.
            </p>
          </BodyContent>
        );
      }
    } else if (currentUser.role === 'MSL') {
      if (currentMonth === startMonth) {
        return (
          <BodyContent>
            <p>
              {SUBMITSUCCESSFUL.DESCRIPTON1} {quarter} {SUBMITSUCCESSFUL.AND} {quarterMonth}{' '}
              {SUBMITSUCCESSFUL.AND} {SUBMITSUCCESSFUL.PROJECTION}
              {SUBMITSUCCESSFUL.DESCRIPTON2} {`${SUBMITSUCCESSFUL.FOR} ${AccountName}`}.
            </p>
          </BodyContent>
        );
      } else {
        return (
          <BodyContent>
            <p>
              {SUBMITSUCCESSFUL.DESCRIPTON1} {quarterMonth} {SUBMITSUCCESSFUL.AND}{' '}
              {SUBMITSUCCESSFUL.PROJECTION} {SUBMITSUCCESSFUL.DESCRIPTON2}{' '}
              {`${SUBMITSUCCESSFUL.FOR} ${AccountName}`}.
            </p>
          </BodyContent>
        );
      }
    }
  };

  const headerTitle = (
    <span style={{ marginLeft: 11, fontSize: 16 }}>{SUBMITSUCCESSFUL.HEADER_TITLE}</span>
  );

  return (
    <MotifModal
      variant="alt"
      show={showSubmitSuccessModal}
      onClose={closeWarningModalByCancel}
      style={{ width: '485px' }}
      focusTrapOptions={{
        initialFocus: false,
      }}
    >
      <MotifModalHeader closeModalButton={true}>
        <Header>
          <img src={success} alt="Success" />
          {headerTitle}
        </Header>
      </MotifModalHeader>
      <MotifModalBody>
        <ParagraphStyle> {bodyContent()}</ParagraphStyle>
      </MotifModalBody>
      <MotifModalFooter>
        {selectedUser?.apiRole !== ROLE_CONST.MSL_DELEGATE && (
          <MotifButton
            variant="secondary"
            className="forecastSubmitButton"
            type="button"
            onClick={closeWarningModal}
          >
            {SUBMITSUCCESSFUL.VIEW_DASBOARD}
          </MotifButton>
        )}
        <MotifButton variant="secondary" type="button" onClick={closeWarningModalByCancel}>
          {BUTTON_TITLE.CLOSE_AND_REFRESH}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};
export default SuccessTransactionModal;
